import { session } from './session';

/**
 * Takes the token out of `?access_token=` before anything else in the app is evaluated.
 *
 * Two separate reasons this has to be an import side effect rather than a statement in `index.tsx`:
 *
 * 1. **The login race.** The identity provider returns the user to `/?access_token=<JWT>`. The route
 *    guard used to read that in a `useEffect` while deciding, during the same render, that there was
 *    no session and it should navigate to `/login`. Both were full-page navigations, and whichever
 *    the browser acted on second cancelled the first -- so a successful login came down to whether
 *    React flushed its passive effects before the document unloaded. Storing the token first means
 *    the very first render already sees an active session and neither navigation happens at all.
 *
 * 2. **`@reach/router`'s location snapshot.** Its `globalHistory` is built when the module is
 *    imported, and `createHistory` reads `window.location` once into a closure
 *    (`@reach/router/lib/history.js`). A module body runs only after *all* of that module's imports
 *    have been evaluated, so a call in `index.tsx` would always lose to it: the url would be
 *    cleaned, but the router would still route off the stale, token-bearing snapshot and put the JWT
 *    back in the address bar -- and from there into history entries and outbound Referer headers.
 *
 * So: `index.tsx` must import this module **before `@reach/router`**. ESLint's `import/order` leaves
 * unassigned imports where they are, so the ordering survives `lint-fix`.
 */
session.captureTokenFromUrl();
